import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import React, { useEffect, useRef, useState } from 'react';
import './index.scss';

const SectionA1: React.FC = () => {
    const { t } = useLang('theProduct.SectionA1');
    const refTargetA = useRef<any>(null);
    const [isEnterA, setIsEnterA] = useState(false);
    useEffect(() => {
        const options = {
            rootMargin: '-150px', //偏移量,-100px表示从底部伸出100px了
            threshold: 0, //0 - 1;0表示监听元素有部分进入了可视区
        };

        const observer = new IntersectionObserver((entries) => {
            const elem = entries[0];

            if (elem.isIntersecting && elem.boundingClientRect.top > 0) {
                setIsEnterA(true);
            } else if (elem.isIntersecting && elem.boundingClientRect.top < 0) {
                setIsEnterA(true);
            } else if (!elem.isIntersecting && elem.boundingClientRect.top > 0) {
                //console.log("leave", "从底部离开");
                //setIsEnterA(false);
            } else {
                //setIsEnterA(false);
                //console.log("leave", "从顶部离开");
            }
        }, options);

        observer.observe(refTargetA.current);
    }, []);
    return (
        <section
            className={`SectionA1${isEnterA ? ' SectionA1-enterA' : ''} GtmModuleData-section`}
            data-section-id="SectionA1"
            data-section-title={t('item1_title')}
        >
            <EcoSpace hPad="100px" />
            <div className="eco-content SectionA1-in" ref={refTargetA}>
                {/* <div className="section-item section-item1">
                    <span className="section-item-msg">{t('item0_title')}</span>
                </div> */}
                <div className="section-item section-item1">
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1745305216204/icon1.png" className="section-item-img" />
                    <span className="section-item-msg">{t('item1_title')}</span>
                </div>
                <div className="section-item section-item2">
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1745305271767/icon2.png" className="section-item-img" />
                    <span className="section-item-msg">{t('item2_title')}</span>
                </div>
                <div className="section-item section-item4">
                    <span className="section-item-msg">
                        <span className="section-item-msg-text">{t('item3_title')}</span>
                        <span className="section-borer-line"></span>
                    </span>
                </div>
            </div>
        </section>
    );
};

export default SectionA1;
